import { RemoveRedEye } from "@mui/icons-material";
import { Pagination } from "@mui/material";
import { Button } from "components/Button/Button";
import IconButton from "components/Button/IconButton";
import NotFound from "components/not-found/NotFound";
import Switch from "components/Switch/Switch";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import ModalBox from "components/modal/ModalBox";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { getProductList, updateStatusOfProduct } from "services/inventorymanagement";

export default function ProductManagementList() {
  const navigate = useNavigate();
  const [record, setRecord] = useState([{}]);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [description, setDescription] = useState("");
  const [statusModal, setStatusModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  // ************************************** Fetch Records **********************************************
  const fetchRecord = async () => {
    showLoader();
    try {
      const res = await getProductList({
        page: activePage,
        search: search,
        limit: limit,
      });
      hideLoader();
      if (res.code === 200) {
        const { rows, count } = res.data.products;
        setRecord(rows || []);
        setTotal(count || 0);
        if (total % limit > 0 || total > limit) {
          setPageCount(Math.round(count / limit) + 1);
        } else {
          setPageCount(Math.round(count / limit) + 1);
        }
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useEffect(() => {
    fetchRecord();
  }, [activePage, search]);

  // ************************************* Update Status ***************************************
  const handleProductStatus = async () => {
    showLoader();
    setSubmitLoading(true);
    try {
        const res = await updateStatusOfProduct({
            productid: selectedId,
        });
        hideLoader();
        setSubmitLoading(false);
        if (res.code === 200) {
          setSubmitLoading(false);
          setStatusModal(false);
          fetchRecord();
          toast.success(res.message);
        } else {
          setSubmitLoading(false);
          setStatusModal(false);
          fetchRecord();
          toast.error(res.message);
        }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
    setSubmitLoading(false);
  };

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap w60per">
                <div className="SearchBox w-100 " style={{ gap: "2px" }}>
                  <div className="div_wrap mx-1 w40per"></div>
                  <div className="div_wrap mx-1 w40per">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control"
                      name="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div>
                    <Button to={"add-product"}>Add&nbsp;Product</Button>
                  </div>
                </div>
              </div>
              <h4 className="Title">Inventory Management</h4>
            </div>

            {loader}
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th className="border-right">S.No</th>
                    <th className="border-right">Item Code</th>
                    <th className="border-right">Product Name</th>
                    <th className="border-right">Category</th>
                    {/* <th className="border-right">Product Code</th> */}
                    <th className="border-right">Cost Price</th>
                    <th className="border-right">Selling Price</th>
                    <th className="border-right">Quantity</th>
                    <th className="border-right text-center">
                      Product Description
                    </th>
                    <th className="border-right text-center">Status</th>
                    <th className="text-center ">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      (
                        {
                          productid,
                          producttitle,
                          productdescription,
                          productcode,
                          costprice,
                          sellingprice,
                          quantity,
                          itemcode,
                          status,
                          addedon,
                          addedby,
                          categoryid,
                          categoryname,
                          categorydescription,
                        },
                        i
                      ) => (
                        <tr key={i}>
                          <td className="w100px">
                            {++i + (activePage - 1) * limit}
                          </td>
                          <td>{itemcode}</td>
                          <td>{producttitle}</td>
                          <td>{categoryname}</td>
                          {/* <td>{productcode}</td> */}
                          <td>{costprice}</td>
                          <td>{sellingprice}</td>
                          <td>{quantity}</td>
                          <td className="w200px">
                            <div className="d-flex justify-content-center">
                              <div className="inline-block my-auto">
                                <IconButton
                                  aria-label="view"
                                  className="px-2 py-0"
                                  onClick={() => {
                                    setViewModal(true);
                                    setDescription(productdescription);
                                  }}
                                >
                                  <RemoveRedEye sx={{ color: "#4971B2" }} />
                                </IconButton>
                              </div>
                            </div>
                          </td>
                          <td className="w100px">
                            <div className="d-flex justify-content-center">
                              <Switch
                                checked={status}
                                onChange={() => {
                                  setSelectedId(productid);
                                  setStatusModal(true);
                                }}
                              />
                            </div>
                          </td>
                          <td className="w100px">
                            <div className="d-flex justify-content-center">
                              <div className="inline-block my-auto">
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                  onClick={() => {
                                    navigate(`update-product/${productid}`);
                                  }}
                                >
                                  <EditIcon sx={{ color: "#4971B2" }} />
                                </IconButton>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={12} />
                  )}
                </tbody>
              </Table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  siblingCount={2}
                  page={activePage}
                  count={pageCount}
                  onChange={(e, value) => {
                    setActivePage(value);
                  }}
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/* ***********************************  View Description ****************************************** */}
      <ModalBox
        status={viewModal}
        onClose={() => setViewModal(false)}
        size={"sm"}
        title={"View Product Description"}
        description={
          <>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <div className="form-group row mt-1">
                  <div className="col-md-12 col-form-label order-1 d-flex flex-column justify-content-end">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-sm-12 col-form-label">
                            <textarea
                              type="text"
                              readonly
                              disabled={true}
                              name="description"
                              value={description}
                              placeholder="Enter Product Description"
                              className={`form-control `}
                              rows={4}
                              label={"Description"}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        customizedFooter={true}
        Close={true}
        custom={false}
      />

      {/* ***********************************  Update Status Of Category ****************************************** */}
      <ModalBox
        status={statusModal}
        onClose={() => setStatusModal(false)}
        title={"Change Status"}
        description={"Are you sure? You want to change status"}
        customizedFooter={
          <>
            <Button onClick={handleProductStatus} {...submitButtonElement}>
              Yes
            </Button>
          </>
        }
        // Close={true}
        // custom={false}
      />
    </>
  );
}
